import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import _ from 'lodash';
import { SurveyRepositoryService } from './survey-repository.service';

@Injectable({
  providedIn: 'root'
})
export class AnswersRepositoryService {
  
  answers = this.getAnswersObject();
  sentAnswers = this.getSentAnswers();
  currentUser;
  latitude = "";
  longitude = "";

  answersCount: number;
  answersCountChange: Subject<number> = new Subject<number>;

  constructor(
    private surveyRepository: SurveyRepositoryService
  ) {

    this.answersCountChange.subscribe((value) => {
      this.answersCount = value
    });
    
    this.updateAnswerCount();
  }

  getAnwserCount(): number {
    return this.answersCount;
  }

  setAnswerCount(value: number) {
    this.answersCountChange.next(value);
  }

  userHasAnswers(user: any): boolean {
    const answers = user?.answers ?? [];
    if (!answers.length) {
      return false;
    }

    for (const userAnswers of answers) {
      for (const a of userAnswers?.answer ?? []) {
        if (typeof a.value === 'string') {
          return true;
        }
        if (Array.isArray(a.value) && a.value.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  countUsersWithAnswers(users: any[] = []): number {
    return users.filter((user) => this.userHasAnswers(user)).length;
  }

  updateAnswerCount() {
    let count = 0;
    this.getForms().forEach((form) => {
      count += this.countUsersWithAnswers(form.users);
    });
    this.setAnswerCount(count);
  }
  
  getSentAnswers() {
    var sent = localStorage.getItem('sent');
    
    if (sent) {
      return JSON.parse(sent);
    }
    return { forms :[]};
  };

  saveSentAnswers() {
    if (this.sentAnswers) {
      localStorage.setItem('sent', JSON.stringify(this.sentAnswers));
      this.updateAnswerCount();
    }
  };
  
  getAnswersObject() {
    var answersString = localStorage.getItem('answers');
    
    if (answersString) {
      return JSON.parse(answersString);
    }
    return{
      forms: []
    };
  }
  
  saveAnswersObject() {
    if (this.answers) {
      localStorage.setItem('answers', JSON.stringify(this.answers));
      this.updateAnswerCount();
    }
  }
  
  clearSentAnswers = function(){
    this.sentAnswers.forms = [];
    this.saveSentAnswers();
  }
  
  getLatitude  = function(){
    return  this.latitude;
  };
  
  getLongitude  = function(){
    return  this.longitude;
  };
  
  setLatitude = function (value) {
    this.latitude = value;
  };
  
  setLongitude  = function(value){
    this.longitude = value;
  };
  
  getAnswers  = function(){
    return  this.answers;
  };

  resultSent = function(){
    this.getForms().forEach(function(form){
      const sentUsersCount = this.countUsersWithAnswers(form.users);
      if (!sentUsersCount) {
        return;
      }

      var sentForm = this.getSentForm(form.id);
      if( sentForm == null) {
        sentForm = {
          id: form.id,
          title: form.title,
          sent:0,
          sentAt:0
        }
        this.getSentForms().push(sentForm);
      }
      sentForm.sent += sentUsersCount;
      sentForm.sentAt = _.now();
    },this);
    this.setForms([]);
    this.saveSentAnswers();
  };
  
  //suuprime une question de la liste des questions du sondé actuel
  deleteAnswer = function(questionId) {
    var question = this.findQuestion(questionId);
    if (question != null) {
      this.currentUser.answers.splice(this.currentUser.answers.indexOf(question), 1);
    }
  };
  
  /**
  Retourne la réponse à la question identifiée par 'questionId' null si la question n'a pas encore été renseignée.
  */
  findQuestion = function(questionId) {
    return this.currentUser.answers.find(function(answer) {
      return answer.questionId == questionId;
    });
  };
  
  getForms = function() {
    return this.answers.forms;
  };
  getSentForms = function(){
    return this.sentAnswers.forms;
  }
  
  setForms = function(forms) {
    this.answers.forms = forms;
    this.saveAnswersObject();
  };
  
  getCurrentUser = function () {
    return this.currentUser;
  };
  
  setCurrentUser = function (value) {
    this.currentUser = value;
    
  };

  markQuestionStartTimestampIfUnset = function (timestamp: number = Date.now()) {
    if (!this.currentUser) return;
    if (this.currentUser.questionStartTimestamp != null) return;
    this.currentUser.questionStartTimestamp = timestamp;
    this.currentUser.questionStartTimestampSource = 'touch';
  };

  private finalizeUserTiming(user: any) {
    if (!user || user.questionDurationMs != null) {
      return;
    }

    // Par défaut on considère qu'on peut compter à partir du lancement pour les anciens enregistrements.
    // Si explicitement `false`, on exige que le "premier touch/click" ait démarré le compteur.
    const countFromLaunch = user.questionCountFromLaunch !== false;

    let startTs = Number(user.questionStartTimestamp);
    if (!Number.isFinite(startTs)) {
      if (!countFromLaunch) return;

      const parsed = (() => {
        // `questionDate` est au format `YYYY-M-D HH:mm:ss` (sans padding sur M/D),
        // `Date.parse` peut être permissif mais on préfère un parsing déterministe.
        const s = String(user.questionDate || '').trim();
        if (!s) return NaN;
        const parts = s.split(' ');
        if (parts.length < 2) return NaN;
        const [datePart, timePart] = parts;
        const [y, m, d] = datePart.split('-').map(Number);
        const [hh, mm, ss] = timePart.split(':').map(Number);
        if (![y, m, d, hh, mm, ss].every(Number.isFinite)) return NaN;
        return new Date(y, m - 1, d, hh, mm, ss).getTime();
      })();

      startTs = Number.isFinite(parsed) ? parsed : Date.now();
    }

    const endTs = Date.now();
    const durationMs = Math.max(0, endTs - startTs);

    user.questionStartTimestamp = startTs;
    user.questionEndTimestamp = endTs;
    user.questionDurationMs = durationMs;
    user.questionDurationSec = Math.round(durationMs / 1000);
  }
  
  addUserAnswers = function (idForm, user) {
    // Lors d'un sondage mono page l'objet Answers est déjà rempli lors de l'appel de cette fonction dans la page end-survey 
    // => donc il ne faut pas l'ecraser
    const isMono = this.surveyRepository.isDisplayMonoPage();
    const answersObj = this.getAnswersObject();
    const isThereAnyForm = answersObj?.forms?.length != 0;

    if (isMono && isThereAnyForm) {
      const currentForm = this.getForm(idForm);
      if (currentForm?.users?.length) {
        currentForm.users.forEach((u) => this.finalizeUserTiming(u));
      } else {
        this.finalizeUserTiming(user);
      }
      return;
    }

    this.finalizeUserTiming(user);
    if (!this.userHasAnswers(user)) {
      return;
    }

    //récupérer le formulaire
    var currentForm = this.getForm(idForm);

    if (currentForm == null) {
      currentForm = { 'id': idForm };
      this.getForms().push(currentForm);
    }
    if (currentForm.users == null) {
      var users = [];
      users.push(user);
      currentForm['users'] = users;
    } else {
      currentForm.users.push(user);
    }
    this.saveAnswersObject();
  };
  
  /**
  Enregistre la réponse de la question actuelle à la liste des réponses du sondés en cours.
  @param questionId identifiant de la question en cours
  @param currentAnswer réponse du sondé
  */
  saveAnswer = function (questionId, currentAnswer) {
    // En mode "auto-start" (startFormTimer > 0), le compteur doit démarrer à la première réponse.
    // Fallback robuste : si le listener touch/click n'a pas réussi à démarrer, on démarre ici.
    if (
      this.currentUser?.questionCountFromLaunch === false &&
      this.currentUser?.questionStartTimestamp == null
    ) {
      this.markQuestionStartTimestampIfUnset(Date.now());
    }

    var answer = [];
    answer.push({ 'value': currentAnswer });
    var answersList = {
      'questionId': questionId,
      'answer': answer
    };
    var foundQuestion = this.findQuestion(questionId);
    if (foundQuestion != null){
      foundQuestion.answer = answer;
    }
    else {
      this.getCurrentUser().answers.push(answersList);
    }
  };
  
  /**
  Obtient le formulaire identifié par 'id'
  Retourne undefined si aucun formulaire n'est identifié.
  */
  getForm = function(id) {
    return this.answers.forms.find(function (form) {
      return form.id == id;
    });
  };
  getSentForm = function(id) {
    return this.sentAnswers.forms.find(function (form) {
      return form.id == id;
    });
  };
  
  /**
  Réinitialisation à chaque nouvel utlisateur
  */
  resetUser = function () {
    this.currentUser = [];
  };
}
